export enum Events {
    TRIGGER_SUBMIT_DECLARATION = 'triggerSubmitDeclaration',
    TRIGGER_SAVE_DECLARATION_AS_DRAFT = 'triggerSaveDeclarationAsDraft',
    TRIGGER_SAVE_PRODUCT = 'triggerSaveProduct',
    TRIGGER_CANCEL_SAVE_PRODUCT = 'triggerCancelSaveProduct',
    TRIGGER_VALIDATE_MASTER_FORM = 'triggerValidateMasterForm',
    MASTER_FORM_VALIDATION_END = 'masterFormValidationEnd',
    BEFORE_DECLARATION_SAVE = 'beforeDeclarationSave',
    AFTER_DECLARATION_SAVE = 'afterDeclarationSave',
    INVOICE_NUMBER_CHANGED = 'invoiceNumberChanged',
    HANDLE_INVOICE_MODAL = 'handleInvoiceModal',
    INVOICE_FAILED_INITIALLY = 'invoiceFailedInitially',
    INVOICE_MODAL_SAVED = 'invoiceModalSaved',
    SAVING_DECLARATION_START = 'savingDeclarationStart',
    SAVING_DECLARATION_END = 'savingDeclarationEnd',
    DECLARATION_SUBMITTED_SUCCESS = 'declarationSubmittedSuccess',
    ADDED_EXISTING_JOB_TO_MANIFEST = 'addedExistingJobToManifest',
    ADDED_THIRD_PARTY_JOB_TO_MANIFEST = 'addedThirdPartyJobToManifest',
    INVOICE_HISTORY_UPDATED = 'invoiceHistoryUpdated',
}
